<template>
<div class="chapter">
<div class="inner_page">
<div class="toc">
<h1 class="title">Table of Contents</h1>
<div class="toc_entry">
<span href="#/ttp01" title="Link target outside of Sample"><span>Title Page</span></span><br/>
<span href="#/cop01" title="Link target outside of Sample"><span>Copyright Page</span></span><br/>
<span href="#/ded01" title="Link target outside of Sample"><span>Dedication</span></span><br/>
<a href="#/ack01"><span>ACKNOWLEDGMENTS</span></a><br/>
<a href="#/for01"><span>FOREWORD</span></a><br/>
<span href="#/cha01" title="Link target outside of Sample"><span>One: IN THE BEGINNING</span></span><br/>
<span href="#/cha02" title="Link target outside of Sample"><span>Two: TRADITIONS AND CELEBRATIONS</span></span><br/>
<span href="#/cha03" title="Link target outside of Sample"><span>Three: WHEN TITANS TRULY WERE</span></span><br/>
<span href="#/cha04" title="Link target outside of Sample"><span>Four: THE ARTS AND THE SCIENCES</span></span><br/>
<span href="#/cha05" title="Link target outside of Sample"><span>Five: SPECIAL PLACES, SPECIAL MEMORIES</span></span><br/>
<span href="#/cha06" title="Link target outside of Sample"><span>Six: ON THE FIELD AND ON THE COURT</span></span>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc01.vue?6a522ce7